import { useCallback } from 'react'
import Draggable from 'react-draggable'

import { F0Box, F0Button, F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { useDocumentReview } from 'modules/documents/hooks/documents/useDocumentReview'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

import dots from './dots.svg'
import './index.styles.css'

interface Props {
  document: Document | undefined
}

const centerElement = (elm: HTMLElement | null | undefined) => {
  if (!elm) return

  const parent = elm.parentElement

  if (!parent) return

  const width = parent.offsetWidth / 2 - elm.offsetWidth / 2
  elm.style.left = `${width}px`
  elm.style.opacity = '1'
}

const ReviewPromptF0 = ({ document }: Props) => {
  const { loading, review, approve, reject } = useDocumentReview(document?.id)

  const setWidth = useCallback(centerElement, [])

  if (document?.folder?.showOnly) return null

  if (loading) return null

  if (!review) return null

  if (review.isSubmitted) return null

  return (
    <Draggable bounds="parent">
      <div ref={setWidth} className={'ReviewPrompt_root'}>
        <F0Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="between"
          padding="sm"
          background="primary"
          borderRadius="md"
          border="default"
        >
          <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm">
            <img src={dots} />
            <F0Text variant="body" content={i18n.t('reviews.documents.require_approval')} />
          </F0Box>
          <F0Box display="flex" flexDirection="row" gap="xs">
            <F0Button
              onClick={reject}
              variant="critical"
              label={i18n.t('reviews.documents.reject')}
            />
            <F0Button
              onClick={approve}
              variant="default"
              label={i18n.t('reviews.documents.approve')}
            />
          </F0Box>
        </F0Box>
      </div>
    </Draggable>
  )
}

export default ReviewPromptF0
